<script>
import baseMixin from '@/mixins/baseMixin'
import YesNoField from '@/models/forms/fields/yesNoField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionYesNoField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: YesNoField,
      required: true,
    },
    value: {
      type: [Boolean, null],
      default: null,
    },
  },
  computed: {
    compResponse() {
      if (this.value === null) return ''
      return this.value ? this.$t('general.yes') : this.$t('general.no')
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <span class="font-weight-medium">{{ compResponse }}</span>
    </InfoLabel>
  </div>
</template>
